// Static docs hosted on the frontend's public folder.
// CDN-cached and ALWAYS available (no backend cold start).
export const STATIC_DOCS = {
  manual: { url: '/docs/manual-completo-travel-empire.pdf', filename: 'Manual_Completo_Travel_Empire.pdf' },
  guia: { url: '/docs/manual-completo-travel-empire.pdf', filename: 'Manual_Completo_Travel_Empire.pdf' },
  faq: { url: '/docs/manual-completo-travel-empire.pdf', filename: 'Manual_Completo_Travel_Empire.pdf' },
  libro: { url: '/docs/manual-completo-travel-empire.pdf', filename: 'Manual_Completo_Travel_Empire.pdf' },
  adendum_compensacion: { url: '/docs/adendum-plan-compensacion-2026-05-04.pdf', filename: 'Adendum_Plan_Compensacion_2026-05-04.pdf' },
  surety_bond: { url: '/docs/surety-bond.pdf', filename: 'Surety_Bond_Tons_of_Leads_LLC.pdf' },
  fdacs_license: { url: '/docs/fdacs-license.pdf', filename: 'FDACS_License_ST39568.pdf' },
  florida_certificate_2026: { url: '/docs/florida-seller-travel-certificate-2026.pdf', filename: 'Florida_Seller_of_Travel_Certificate_2026.pdf' },
};

// Returns an inline-renderable iframe URL (works across all browsers/devices,
// including mobile Safari which would otherwise download a raw PDF).
// Uses Google's gview embedded viewer for the public PDF URL.
export function getInlineViewerUrl(docKey) {
  const doc = STATIC_DOCS[docKey];
  if (!doc) return null;
  const absoluteUrl = `${window.location.origin}${doc.url}`;
  return `https://docs.google.com/gview?url=${encodeURIComponent(absoluteUrl)}&embedded=true`;
}

export default STATIC_DOCS;
